







































import {Component} from "vue-property-decorator"
import BaseVue from "@/utils/BaseVue"
import {StoreData} from "@/store/stores.module"
import apiService from "@/services/api.service"
import logger from "@/utils/logging"

@Component
export default class Sidebar extends BaseVue {

  private isPdfDataLoading: boolean = false

  private get storeName(): string {
    const storeInfo = this.storeData.info
    return storeInfo.name.replace(RegExp(`^${storeInfo.retailGroupId} `, "i"), "")
  }

  private get isStoreLoading(): boolean {
    return this.$typedStore.getters.stores.isStoreLoading(this.storeId)
  }

  private get storeLogo() {
    try {
      return require(`@/assets/${this.storeData.info.retailGroupId.replace(/[' ]/, "").toLowerCase()}.png`)
    } catch (e) {
      return null
    }
  }

  private get storeData(): StoreData {
    return this.$typedStore.state.stores[this.storeId].data!
  }

  private get storeId(): number {
    // tslint:disable no-string-literal
    return Number(this.$route.params["storeId"])
  }

  public async onPrintPdf(category: string) {
    const storeId = this.storeId.toString()
    const storeInfo = this.storeData.info

    this.isPdfDataLoading = true
    try {
      const pdfBlob = await apiService.fetchActiveCategoryProductsPdfData(storeId, category)

      const link = document.createElement("a")
      link.download = `${category}-non-eans-(${storeInfo.name}).pdf`
      link.rel = "noopener"
      const downloadUrl = URL.createObjectURL(pdfBlob)
      link.href = downloadUrl

      setTimeout(() => {
        URL.revokeObjectURL(link.href)
      }, 40000) // 40s
      setTimeout(() => {
        link.click()
        this.isPdfDataLoading = false
      }, 0)
    } catch (error) {
      logger.error(`Failed to generate pdf in store ${storeId}`, error)
      this.isPdfDataLoading = false
    }
  }

}
